import React, { memo } from 'react';
import { AGENT_STATUS } from '../constants';

/**
 * Loading overlay component
 * Shows when connecting or when agent is generating with no messages
 */
const LoadingOverlay = memo(({ 
  isEventConnected, 
  agentStatus, 
  validMessagesCount,
  systemMessage: _systemMessage 
}) => {
  // Determine if we should show the loading overlay
  const shouldShowOverlay = (!isEventConnected) ||
                           (agentStatus === AGENT_STATUS.GENERATING && validMessagesCount === 0);

  if (!shouldShowOverlay) return null;

  return (
    <div className="absolute inset-0 bg-white/80 dark:bg-neutral-900/80 backdrop-blur-sm flex items-center justify-center z-20">
      <div className="text-center">
        <div className="mb-4">
          <div className="flex justify-center space-x-2">
            <span className="w-3 h-3 bg-brand-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
            <span className="w-3 h-3 bg-brand-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
            <span className="w-3 h-3 bg-brand-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
          </div>
        </div>
        
        {!isEventConnected ? (
          <p className="text-neutral-600 dark:text-neutral-400 text-sm">
            Connecting to agent...
          </p>
        ) : (
          <p className="text-neutral-600 dark:text-neutral-400 text-sm">
            Agent is thinking...
          </p>
        )}
      </div>
    </div>
  );
});

LoadingOverlay.displayName = 'LoadingOverlay';

export default LoadingOverlay;